module.exports = __webpack_public_path__ + "static/media/view1.2c935106.jpg";